import { render, staticRenderFns } from "./suggestPriceInput.vue?vue&type=template&id=5cbe03c4&scoped=true"
import script from "./suggestPriceInput.vue?vue&type=script&lang=js"
export * from "./suggestPriceInput.vue?vue&type=script&lang=js"
import style0 from "./suggestPriceInput.vue?vue&type=style&index=0&id=5cbe03c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbe03c4",
  null
  
)

export default component.exports